import React, { useState, useEffect } from 'react';
import { Col, Container, Row, Form, Modal } from 'react-bootstrap';
import axios from 'axios';
import Cookies from 'js-cookie';
import user from '../../assets/image 1.png'; // Ensure the correct path to the image
import Button from 'react-bootstrap/Button';

const Profile = () => {
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [profileData, setProfileData] = useState(null);
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const handleResize = () => {
    const mobile = window.innerWidth <= 768;
    setIsMobile(mobile);
  };

  const [formData, setFormData] = useState({
    name: '',
    surname: '',
    email: '',
    contact: '',
    file: null,
    username: '',
    institute: '',
    country: '',
    dob: '',
    educationLevel: '',
    department: '',
    major: ''
  });


  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    // Fetch profile data from the API
    const fetchProfileData = async () => {
      try {
        const response = await axios.get(`https://backend.writerswright.com/api/v1/student/getStudentProfile?Id=${Cookies.get('id')}`);
        setProfileData(response.data);
        setFormData({
          name: response.data.Name,
          surname: response.data.Surname,
          email: response.data.Email,
          contact: response.data.Contact,
          file: null,
          username: response.data.Username,
          institute: response.data.Institute,
          country: response.data.Country,
          dob: response.data.DateOfBirth,
          educationLevel: response.data.EducationalLevel,
          department: response.data.Department,
          major: response.data.Major,
        })
        Cookies.set('uId', response.data.Id)
      } catch (error) {
        console.error('Error fetching profile data:', error);
      }
    };

    fetchProfileData();
  }, []);

  const fetchProfileData = async () => {
    try {
      const response = await axios.get(`https://backend.writerswright.com/api/v1/student/getStudentProfile?Id=${Cookies.get('id')}`);
      setProfileData(response.data);
      setFormData({
        name: response.data.Name,
        surname: response.data.Surname,
        email: response.data.Email,
        contact: response.data.Contact,
        file: null,
        username: response.data.Username,
        institute: response.data.Institute,
        country: response.data.Country,
        dob: response.data.DateOfBirth,
        educationLevel: response.data.EducationalLevel,
        department: response.data.Department,
        major: response.data.Major,
      })
      Cookies.set('uId', response.data.Id)
    } catch (error) {
      console.error('Error fetching profile data:', error);
    }
  };

  const handleProfileModalShow = () => setShowProfileModal(true);
  const handleProfileModalClose = () => setShowProfileModal(false);

  const handlePasswordModalShow = () => setShowPasswordModal(true);
  const handlePasswordModalClose = () => setShowPasswordModal(false);


  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });
  const handleFileChange = (e) => setFormData({ ...formData, file: e.target.files[0] });

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      alert('New passwords do not match');
      return;
    }

    const data = {
      userId: Cookies.get('id'),
      previousPassword: currentPassword,
      newPassword: newPassword
    };

    try {
      const response = await axios.put('https://backend.writerswright.com/api/v1/student/updatepassword', data, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      console.log(response.data); // Log response for debugging
      alert('Password updated successfully.');
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
      handlePasswordModalClose();
    } catch (error) {
      console.error('Error updating password:', error);
      alert('Failed to update password. Please check the server logs.');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const form = new FormData();
      for (const key in formData) {
        form.append(key, formData[key]);
      }

      const response = await axios.put(`https://backend.writerswright.com/api/v1/admin/updateStudent?Id=${Cookies.get('uId')}`, form, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      console.log(response.data); // Log the response for debugging
      fetchProfileData();
      handleProfileModalClose(); // Close the modal after successful submission
    } catch (error) {
      console.error('Error submitting add student form:', error);
      if (error.response) {
        console.error('Server response:', error.response.data); // Log server response for detailed error
        alert(`Failed to add student: ${error.response.data.message}`); // Display server error message to user
      } else {
        alert('Failed to add student. Please check the server logs.'); // Fallback message if no detailed response available
      }
    }
  };


  return (
    <Container>
      <h4 className="title">Profile</h4>
      <div
        style={{
          width: isMobile ? '90%' : '60%',
          height: '100%',
          margin: 'auto',
          borderRadius: '10px',
          marginBottom: '10px',
          boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px',
          padding: '5% 10%',
        }}
      >
        {profileData && (
          <Row>
            <Col lg={6} md={6} sm={12}>
              <div style={{ marginBottom: '10px' }}>
                <strong style={{ color: 'var(--primary)' }}>Name</strong>
              </div>
              <div style={{ marginBottom: '20px' }}>{profileData.Name}</div>

              <div style={{ marginBottom: '10px' }}>
                <strong style={{ color: 'var(--primary)' }}>Surname</strong>
              </div>
              <div style={{ marginBottom: '20px' }}>{profileData.Surname}</div>

              <div style={{ marginBottom: '10px' }}>
                <strong style={{ color: 'var(--primary)' }}>Username</strong>
              </div>
              <div style={{ marginBottom: '20px' }}>{profileData.Username}</div>

              <div style={{ marginBottom: '10px' }}>
                <strong style={{ color: 'var(--primary)' }}>Email</strong>
              </div>
              <div style={{ marginBottom: '20px' }}>{profileData.Email}</div>

              <div style={{ marginBottom: '10px' }}>
                <strong style={{ color: 'var(--primary)' }}>Contact</strong>
              </div>
              <div style={{ marginBottom: '20px' }}>{profileData.Contact}</div>

              <div style={{ marginBottom: '10px' }}>
                <strong style={{ color: 'var(--primary)' }}>Institute</strong>
              </div>
              <div style={{ marginBottom: '20px' }}>{profileData.Institute}</div>
            </Col>

            <Col
              lg={6}
              md={6}
              sm={12}
              // className="d-flex justify-content-center align-items-center"
              style={{ height: 'auto' }}
            >
              <div style={{ marginBottom: '10px' }}>
                <strong style={{ color: 'var(--primary)' }}>Country</strong>
              </div>
              <div style={{ marginBottom: '20px' }}>{profileData.Country}</div>
              <div style={{ marginBottom: '10px' }}>
                <strong style={{ color: 'var(--primary)' }}>Date of Birth</strong>
              </div>
              <div style={{ marginBottom: '20px' }}>{new Date(profileData.DateOfBirth).toLocaleDateString()}</div>

              <div style={{ marginBottom: '10px' }}>
                <strong style={{ color: 'var(--primary)' }}>Educational Level</strong>
              </div>
              <div style={{ marginBottom: '20px' }}>{profileData.EducationalLevel}</div>

              <div style={{ marginBottom: '10px' }}>
                <strong style={{ color: 'var(--primary)' }}>Department</strong>
              </div>
              <div style={{ marginBottom: '20px' }}>{profileData.Department}</div>

              <div style={{ marginBottom: '10px' }}>
                <strong style={{ color: 'var(--primary)' }}>Major</strong>
              </div>
              <div style={{ marginBottom: '20px' }}>{profileData.Major}</div>
              {/* <img
                src={profileData.ProfilePicture ? `https://backend.writerswright.com/${profileData.ProfilePicture}` : user}
                alt="Profile"
                className="img-circle"
                style={{
                  width: '70px',
                  height: '70px',
                  borderRadius: '50%',
                  objectFit: 'cover',
                }}
              /> */}
            </Col>
          </Row>
        )}
        <Row>
          <Col>
            <button
              className="button-37"
              onClick={handleProfileModalShow}
              style={{ marginRight: '5px', marginTop: '5px' }}
            >
              Update Profile
            </button>
            <button
              className="button-37"
              onClick={handlePasswordModalShow}
              style={{ marginTop: '5px' }}
            >
              Update Password
            </button>
          </Col>
        </Row>
      </div>

      {/* Update Profile Modal */}
      <Modal show={showProfileModal} onHide={handleProfileModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>Update Profile</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="formName">
              <Form.Label>Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter name"
                name="name"
                value={formData.name}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group controlId="formSurname">
              <Form.Label>Surname</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter surname"
                name="surname"
                value={formData.surname}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group controlId="formEmail">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                placeholder="Enter email"
                name="email"
                value={formData.email}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group controlId="formContact">
              <Form.Label>Contact</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter contact number"
                name="contact"
                value={formData.contact}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group controlId="formProfilePicture">
              <Form.Label>Profile Picture</Form.Label>
              <Form.Control
                type="file"
                name="profilePicture"
                onChange={handleFileChange}
              />
            </Form.Group>

            <Form.Group controlId="formUsername">
              <Form.Label>Username</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter username"
                name="username"
                value={formData.username}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group controlId="formInstitute">
              <Form.Label>Institute</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter institute"
                name="institute"
                value={formData.institute}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group controlId="formCountry">
              <Form.Label>Country</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter country"
                name="country"
                value={formData.country}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group controlId="formDOB">
              <Form.Label>Date of Birth</Form.Label>
              <Form.Control
                type="date"
                name="dob"
                value={formData.dob}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group controlId="formEducationLevel">
              <Form.Label>Education Level</Form.Label>
              <Form.Control
                as="select"
                name="educationLevel"
                value={formData.educationLevel}
                onChange={handleChange}
              >
                <option value="">Select Education Level</option>
                <option value="High School">High School</option>
                <option value="Undergraduate">Undergraduate</option>
                <option value="Postgraduate">Postgraduate</option>
              </Form.Control>
            </Form.Group>

            <Form.Group controlId="formDepartment">
              <Form.Label>Department</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter department"
                name="department"
                value={formData.department}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group controlId="formMajor">
              <Form.Label>Major</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter major"
                name="major"
                value={formData.major}
                onChange={handleChange}
              />
            </Form.Group>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleProfileModalClose}>
                Close
              </Button>
              <Button variant="primary" type="submit">
                Update Profile
              </Button>
            </Modal.Footer>
          </Form>
        </Modal.Body>
      </Modal>

      {/* Update Password Modal */}
      <Modal show={showPasswordModal} onHide={handlePasswordModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>Update Password</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <Form onSubmit={handlePasswordSubmit}>
            <Form.Group controlId="formOldPassword">
              <Form.Label>Current Password</Form.Label>
              <Form.Control
                type="password"
                placeholder="Enter current password"
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
                required
              />
            </Form.Group>
            <Form.Group controlId="formNewPassword">
              <Form.Label>New Password</Form.Label>
              <Form.Control
                type="password"
                placeholder="Enter new password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
              />
            </Form.Group>
            <Form.Group controlId="formConfirmPassword">
              <Form.Label>Confirm Password</Form.Label>
              <Form.Control
                type="password"
                placeholder="Confirm new password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
              />
            </Form.Group>
            <button className="button-37 mt-2" type="submit" style={{ marginRight: '5px' }}>
              Update Password
            </button>
          </Form>
        </Modal.Body>
      </Modal>
    </Container>
  );
};

export default Profile;
